import { Meta } from '@storybook/addon-docs/blocks';

<Meta title="Overview/Showcase" />

# Showcase

Examples of how these components have been remixed and repurposed.

## In a React App

[Repository](https://github.com/aroseman/gdwc-react-demo) /
[Live Gitpod Environment](https://gitpod.io/#https://github.com/aroseman/gdwc-react-demo/)

<iframe
  src="https://codesandbox.io/embed/github/aroseman/gdwc-react-demo/tree/main/?fontsize=14&hidenavigation=1&theme=dark&view=preview"
  style={{ width: '100%', height: '500px' }}
  title="react-component-demo"
  allow="accelerometer; ambient-light-sensor; camera; encrypted-media; geolocation; gyroscope; hid; microphone; midi; payment; usb; vr; xr-spatial-tracking"
  sandbox="allow-forms allow-modals allow-popups allow-presentation allow-same-origin allow-scripts"
></iframe>

## With Other Web Component Libraries

<iframe
  src="https://codesandbox.io/embed/gdwc-vaadin-menu-bar-eqkg6?fontsize=14&hidenavigation=1&theme=dark&view=preview"
  style={{ width: '100%', height: '500px' }}
  title="GDWC Vaadin Menu Bar"
  allow="accelerometer; ambient-light-sensor; camera; encrypted-media; geolocation; gyroscope; hid; microphone; midi; payment; usb; vr; xr-spatial-tracking"
  sandbox="allow-forms allow-modals allow-popups allow-presentation allow-same-origin allow-scripts"
></iframe>
